import {metadaApi} from '@dms/api/base';

import {
  GetServiceOrderAvailableDocumentsApiResponse,
  GetServiceOrderAvailableDocumentsApiArg,
  GetServiceOrderAvailableDocumentsApiResponseSchema,
  GetServiceOrderAvailableDocumentsApiArgSchema,
  GetServiceOrderBulkPrintDocumentsRestrictionsApiResponse,
  GetServiceOrderBulkPrintDocumentsRestrictionsApiArg,
  GetServiceOrderBulkPrintDocumentsRestrictionsApiResponseSchema,
  GetServiceOrderBulkPrintDocumentsRestrictionsApiArgSchema,
  PostServiceOrderBulkPrintDocumentsApiResponse,
  PostServiceOrderBulkPrintDocumentsApiArg,
  PostServiceOrderBulkPrintDocumentsApiResponseSchema,
  PostServiceOrderBulkPrintDocumentsApiArgSchema,
} from './types';

export const metadaWorkshopServiceOrderDocumentsApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getServiceOrderAvailableDocuments: build.query<
      GetServiceOrderAvailableDocumentsApiResponse,
      GetServiceOrderAvailableDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/available-documents`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'serviceOrder', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetServiceOrderAvailableDocumentsApiResponseSchema,
        requestSchema: GetServiceOrderAvailableDocumentsApiArgSchema,
      },
    }),
    getServiceOrderBulkPrintDocumentsRestrictions: build.query<
      GetServiceOrderBulkPrintDocumentsRestrictionsApiResponse,
      GetServiceOrderBulkPrintDocumentsRestrictionsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/print-documents/restrictions`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'serviceOrder', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetServiceOrderBulkPrintDocumentsRestrictionsApiResponseSchema,
        requestSchema: GetServiceOrderBulkPrintDocumentsRestrictionsApiArgSchema,
      },
    }),
    postServiceOrderBulkPrintDocuments: build.mutation<
      PostServiceOrderBulkPrintDocumentsApiResponse,
      PostServiceOrderBulkPrintDocumentsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/print-documents`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCase', id: queryArg.serviceCaseId},
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        {type: 'serviceOrder', id: queryArg.serviceOrderId},
        {type: 'missingServiceOrderMandatoryFields', id: queryArg.serviceOrderId},
        {type: 'orderActions', id: queryArg.serviceOrderId},
        {type: 'serviceActions', id: queryArg.serviceCaseId},
        {type: 'serviceOrderJobs', id: queryArg.serviceOrderId},
        'afsPaymentIssueRestriction',
      ],
      extraOptions: {
        responseSchema: PostServiceOrderBulkPrintDocumentsApiResponseSchema,
        requestSchema: PostServiceOrderBulkPrintDocumentsApiArgSchema,
      },
    }),
  }),
});

export const {
  useGetServiceOrderAvailableDocumentsQuery,
  useGetServiceOrderBulkPrintDocumentsRestrictionsQuery,
  usePostServiceOrderBulkPrintDocumentsMutation,
} = metadaWorkshopServiceOrderDocumentsApi;
